module.exports = __webpack_public_path__ + "static/media/qwantum.28d9c6bb.png";